/* ================================================== */
/* CONTROLLER → Field
/* ================================================== */

app.controller('fieldCtrl', ['$rootScope', '$scope', function($rootScope, $scope) {

	// Update select
	$scope.updateSelect = function(index, defaultOption, isChecked) {
		$rootScope.formDataRaw[index] = (isChecked == true) ? defaultOption : $rootScope.formDataRaw[index];
	}

	// Sync checkbox
	$scope.syncCheckbox = function(index) {
		$rootScope.formDataRaw[index + 'Checkbox'] = false;
	}

	// Update input[type="checkbox"] w/ keyboard
	$scope.updateCheckboxWithKeyboard = function(index) {
		$rootScope.formDataRaw[index] = ($rootScope.formDataRaw[index] === true) ? false : true;
	}

	// Update input[type="radio"] w/ keyboard
	$scope.updateRadioWithKeyboard = function(index) {
		$rootScope.formDataRaw[index] = event.target.value;
	}

}]);